import React from 'react'

export default function Home() {
  return (
    <h1 class="text-3xl font-bold underline bg" >
    Hello world!
  </h1>
  )
}
